const AppConsts = {
  apiBaseUrl: "https://crmmbmindia.co.in/api",
   //apiBaseUrl: "https://mbmtest.avaniko.com/api",
   //apiBaseUrl:"https://demo.crmmbmindia.co.in/api",
};
export default AppConsts;

export const UiConsts = {
  UiBaseUrl: "https://crmmbmindia.co.in",
  // UiBaseUrl: "https://mbmtest.avaniko.com",
   //UiBaseUrl:"https://demo.crmmbmindia.co.in",
};
